/** Whether editor startup should run full project open before loading the scene. */
export const shouldOpenProjectBeforeStartup = (
  isProjectOpened: boolean,
  projectPath: string,
): boolean => !isProjectOpened && projectPath.trim().length > 0;
